


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Alert, Table } from 'react-bootstrap';
import axios from 'axios';
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const AddCart = () => {
    const navigate = useNavigate();
    
    const [cartItems, setCartItems] = useState(() => {
        const savedCart = localStorage.getItem('cart');
        try { return savedCart ? JSON.parse(savedCart) : []; } catch (e) { return []; }
    });
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [shippingAddress, setShippingAddress] = useState('');
    const [orderLoading, setOrderLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [error, setError] = useState('');
    const [orderDetails, setOrderDetails] = useState(null);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        checkAuthStatus();
        window.scrollTo(0, 0);
    }, []);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) {
            setIsLoggedIn(true);
            const parsedUser = JSON.parse(user);
            setCurrentUser(parsedUser);
            setCustomerName(parsedUser.name || '');
            setCustomerEmail(parsedUser.email || '');
            setCustomerPhone(parsedUser.phoneNumber || '');
            setShippingAddress(parsedUser.address || '');
        }
    };

    const updateQuantity = (id, delta) => {
        const updated = cartItems.map(item => {
            if (item.id === id) {
                const newQty = Math.max(1, Math.min(item.availableQuantity || 99, item.quantity + delta));
                return { ...item, quantity: newQty };
            }
            return item;
        });
        setCartItems(updated);
        localStorage.setItem('cart', JSON.stringify(updated));
    };

    const removeItem = (id) => {
        const filtered = cartItems.filter(item => item.id !== id);
        setCartItems(filtered);
        localStorage.setItem('cart', JSON.stringify(filtered));
    };

    const calculateTotal = () => cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);

    const handleCheckout = async (e) => {
        e.preventDefault();
        setError('');
        if (isLoggedIn && !shippingAddress.trim()) { setError('Please provide shipping address'); return; }
        if (!isLoggedIn && (!customerName.trim() || !customerEmail.trim() || !shippingAddress.trim())) { setError('Please fill all details'); return; }
        
        setOrderLoading(true);
        try {
            const orderPayload = {
                email: (isLoggedIn ? currentUser.email : customerEmail).toLowerCase().trim(),
                customerName: (isLoggedIn ? currentUser.name : customerName).trim(),
                phoneNumber: (isLoggedIn ? (currentUser.phoneNumber || "") : (customerPhone || "")).toString().trim(),
                shippingAddress: shippingAddress.trim(),
                status: "Order Placed",
                items: cartItems.map(item => ({ productId: item.id, quantity: item.quantity }))
            };
            const response = await axios.post(config.APIACTIVEURL + config.CREATEORDER, orderPayload);
            if (response.data.success) {
                setOrderDetails(response.data.data); 
                setShowSuccess(true);
                localStorage.removeItem('cart');
                setCartItems([]);
            } else { throw new Error(response.data.message); }
        } catch (err) { setError(err.response?.data?.message || "Order failed"); } finally { setOrderLoading(false); }
    };

    const formatCurrency = (amt) => `${currency} ${Number(amt).toFixed(2)}`;

    return (
        /* pt-5 and mt-5 added to fix header merge */
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh' }} className="pt-5 mt-5 pb-5">
            <div className="container py-2">
                
                {/* NEW GO BACK BUTTON FOR CART */}
                <div className="d-flex align-items-center mb-4">
                    <button onClick={() => navigate(-1)} className="btn border-0 p-0 me-3 shadow-none"><i className="ri-arrow-left-line fs-2"></i></button>
                    <h3 className="fw-bold mb-0" style={{ color: THEME_COLOR }}>Cart Summary</h3>
                </div>

                {!cartItems || cartItems.length === 0 ? (
                    <div className="text-center py-5 bg-white rounded-4 shadow-sm border">
                        <i className="ri-shopping-cart-line display-1 text-muted opacity-25"></i>
                        <h4 className="mt-3 text-muted">Your cart is empty</h4>
                        <Button onClick={() => navigate('/products/search')} className="mt-3 rounded-pill" style={{backgroundColor: THEME_COLOR, border:'none'}}>Start Shopping</Button>
                    </div>
                ) : (
                    <div className="row g-4">
                        <div className="col-lg-7">
                            <div className="card border-0 shadow-sm rounded-4 bg-white p-2">
                                {cartItems.map(item => (
                                    <div key={item.id} className="p-3 border-bottom">
                                        <div className="row align-items-center g-2">
                                            <div className="col-3 col-md-2">
                                                <img src={item.image || 'https://placehold.co/70'} className="img-fluid rounded border" style={{ height: '60px', width: '60px', objectFit: 'contain' }} alt={item.name} />
                                            </div>
                                            <div className="col-9 col-md-4 text-start">
                                                <h6 className="fw-bold mb-0 small">{item.name}</h6>
                                                <p className="text-success small fw-bold mb-0">{formatCurrency(item.price)}</p>
                                            </div>
                                            <div className="col-8 col-md-4">
                                                <div className="d-flex align-items-center gap-2">
                                                    <Button variant="light" className="rounded-circle p-0" style={{width:'25px', height:'25px'}} onClick={() => updateQuantity(item.id, -1)}>-</Button>
                                                    <span className="small fw-bold">{item.quantity}</span>
                                                    <Button variant="light" className="rounded-circle p-0" style={{width:'25px', height:'25px'}} onClick={() => updateQuantity(item.id, 1)}>+</Button>
                                                </div>
                                            </div>
                                            <div className="col-4 col-md-2 text-end">
                                                <button className="btn text-danger p-0" onClick={() => removeItem(item.id)}><i className="ri-delete-bin-line"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className="card border-0 shadow-sm p-4 rounded-4 bg-white sticky-lg-top" style={{top: '120px'}}>
                                <h5 className="fw-bold mb-4">Checkout Details</h5>
                                <Form onSubmit={handleCheckout}>
                                    {error && <Alert variant="danger" className="small">{error}</Alert>}
                                    {isLoggedIn ? (
                                        <div className="p-2 border rounded bg-light small mb-3 text-start">Logged in as: <strong>{currentUser?.name}</strong></div>
                                    ) : (
                                        <div className="row g-2 mb-3">
                                            <div className="col-6"><Form.Control size="sm" placeholder="Name" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
                                            <div className="col-6"><Form.Control size="sm" placeholder="Email" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
                                        </div>
                                    )}
                                    <Form.Control as="textarea" rows={3} className="small mb-4" placeholder="Shipping Address" value={shippingAddress} onChange={e => setShippingAddress(e.target.value)} required />
                                    <div className="d-flex justify-content-between mb-4 border-top pt-3">
                                        <span className="fw-bold">Total Payable</span>
                                        <span className="fw-bold text-success h5">{formatCurrency(calculateTotal())}</span>
                                    </div>
                                    <Button type="submit" className="w-100 py-3 fw-bold text-white border-0 rounded-pill shadow-sm" style={{ backgroundColor: THEME_COLOR }} disabled={orderLoading}>
                                        {orderLoading ? 'Processing...' : 'Place Order'}
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* SUCCESS MODAL - REMAINS 100% ORIGINAL FEATURES */}
            <Modal show={showSuccess} onHide={() => navigate('/')} centered backdrop="static" size="lg">
                <Modal.Body className="p-4 p-md-5">
                    <div className="text-center mb-4">
                        <i className="ri-checkbox-circle-fill text-success display-3 mb-2"></i>
                        <h2 className="fw-bold">Confirmed!</h2>
                        <p className="text-muted">Summary of your order:</p>
                    </div>
                    {orderDetails && (
                        <div className="border rounded-4 p-3 bg-light mb-4 text-start">
                            <Table responsive borderless className="small mb-0">
                                <thead className="border-bottom"><tr><th>Item</th><th className="text-center">Qty</th><th className="text-end">Total</th></tr></thead>
                                <tbody>{Array.isArray(orderDetails) ? orderDetails.map((item, i) => (
                                    <tr key={i}><td><div className="fw-bold">{item.productName || 'Product'}</div></td><td className="text-center">{item.quantity}</td><td className="text-end">{formatCurrency(item.totalAmount || item.unitPrice * item.quantity)}</td></tr>
                                )) : (<tr><td><div className="fw-bold">{orderDetails.productName || 'Order'}</div><small>No: {orderDetails.orderNo}</small></td><td className="text-center">{orderDetails.quantity || '1'}</td><td className="text-end">{formatCurrency(orderDetails.totalAmount)}</td></tr>)}</tbody>
                            </Table>
                            <div className="d-flex justify-content-between border-top pt-2 mt-2"><span className="fw-bold">Total Paid:</span><span className="fw-bold text-success">{formatCurrency(Array.isArray(orderDetails) ? orderDetails.reduce((s, i) => s + (i.totalAmount || 0), 0) : orderDetails.totalAmount)}</span></div>
                        </div>
                    )}
                    <Button onClick={() => navigate('/')} className="w-100 py-3 text-white border-0 rounded-pill" style={{ backgroundColor: THEME_COLOR }}>Return to Home</Button>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AddCart;